import React, { useState } from 'react';
import './EKPlanningWes.css';
import { Col, Row, Container, Table } from "react-bootstrap";

const EkPlanningWes = () => {

    const [ekPlanningAllInOne, setEkPlanningAllInOne] = useState({

        wareKollectionPercent: "60.0",
        wareKollectionPercentValue: "0",
        wareKollectionVoOrderPercent: "100",
        wareKollectionVoOrderPercentValue: "0",
        wareKollectionNachorderPercent: "0.0",
        wareKollectionNachorderPercentValue: "",
        wareNosPercent: "40.0",
        wareNosPercentValue: "0",
        wareNosVoOrderPercent: "60",
        wareNosVoOrderPercentValue: "0",
        wareNosNachorderPercent: "40.0",
        wareNosNachorderPercentValue: "0"

    });

    const [checkBox1, setCheckBox1] = useState(true);
    const [checkBox2, setCheckBox2] = useState(true);
    const [checkBox3, setCheckBox3] = useState(true);

    const getCheckValue = (e) => {
        const { name, checked } = e.target;
        if (name === "Wareneingang") {
            setCheckBox1(checked);
        } else if (name === "Abschrift") {
            setCheckBox2(checked);
        } else if (name === "Eingangskalkulation") {
            setCheckBox3(checked);
        }
    };

    const getValueCheck = (e) => {
        const { name, value } = e.target;
        
        // ✅ allow only digits + optional one decimal
        if (!/^\d*\.?\d*$/.test(value)) {
            return; // ❌ block alphabets & symbols
        }

        setEkPlanningAllInOne((prev) => ({
            ...prev,
            [name]: value,
        }));

        // if parent take data
        // onValueChange?.({
        //   ...ekPlanningAllInOne,
        //   [name]: value,
        // });
    };


    return (
        <div className="p-2 border rounded bg-white">
            <div className="ekPlanning-wes1CheckboxMain mb-2">
                <Row className="p-2">
                    {/* <div className="wes1CheckboxMain"> */}
                    <Col className="ekPlanning-wes1CheckboxMainContainer">
                        <div className="ekPlanning-wes1CheckboxMainContainerinputMain">
                            <input
                                type="checkbox"
                                className="ekPlanning-wes1CheckboxMainContainerinputTag"
                                onChange={getCheckValue}
                                checked={checkBox1}
                                name="Wareneingang"
                            />
                        </div>
                        <div className="ekPlanning-wes1CheckboxMainContainertext">Wareneingang</div>
                    </Col>
                    <Col className="ekPlanning-wes1CheckboxMainContainer">
                        <div className="ekPlanning-wes1CheckboxMainContainerinputMain">
                            <input
                                type="checkbox"
                                className="ekPlanning-wes1CheckboxMainContainerinputTag"
                                onChange={getCheckValue}
                                checked={checkBox2}
                                name="Abschrift"
                            />
                        </div>
                        <div className="ekPlanning-wes1CheckboxMainContainertext">
                            Vororder Nachorder
                        </div>
                    </Col>
                </Row>
            </div>
            <Table
                bordered
                hover
                responsive
                size="sm"
                className="ekPlanning-planing_wes1-table1 p-0 m-0"
                align-middle="text-center"
            >
                <thead className="ekPlanning-table-warning">
                    <tr>
                        {checkBox1 && <th colSpan={3}></th>}

                        {checkBox2 && (
                            <>
                                <th colSpan={2}>Vororder</th>
                                <th colSpan={2}>Nachorder</th>
                            </>
                        )}

                        {/* {checkBox3 && <th colSpan={8}></th>} */}
                    </tr>

                    <tr>
                        {checkBox1 && (
                            <>
                                <th rowSpan={2}>Wareneingang</th>
                                <th rowSpan={2}>Prozent</th>
                                <th rowSpan={2}>Wert</th>
                            </>
                        )}

                        {checkBox2 && (
                            <>
                                <th rowSpan={2}>%</th>
                                <th rowSpan={2}>Wert</th>
                                <th>%</th>
                                <th>Wert</th>
                            </>
                        )}
                    </tr>
                </thead>

                <tbody className="ekPlanning-wes1-tbody">
                    {/* Row 1 */}
                    <tr>
                        {checkBox1 ? (
                            <>
                                <td
                                    style={{ background: "rgb(236 245 166)" }}
                                    className="wes1td"
                                >
                                    Kollektion
                                </td>
                                <td>
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        name="wareKollectionPercent"
                                        value={ekPlanningAllInOne.wareKollectionPercent}
                                        onChange={getValueCheck}
                                        autoComplete="off"
                                    />
                                </td>
                                <td>
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        name="wareKollectionPercentValue"
                                        value={ekPlanningAllInOne.wareKollectionPercentValue}
                                        onChange={getValueCheck}
                                    />
                                </td>
                            </>
                        ) : null}
                        {checkBox2 ? (
                            <>
                                <td>
                                    {" "}
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareKollectionVoOrderPercent"
                                        value={ekPlanningAllInOne.wareKollectionVoOrderPercent}
                                        onChange={getValueCheck}
                                    />
                                </td>
                                <td>
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareKollectionVoOrderPercentValue"
                                        value={ekPlanningAllInOne.wareKollectionVoOrderPercentValue}
                                        onChange={getValueCheck}
                                    />
                                </td>
                                <td style={{ background: "rgb(236 245 166)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareKollectionNachorderPercent"
                                        value={ekPlanningAllInOne.wareKollectionNachorderPercent}
                                        onChange={getValueCheck}
                                        style={{ background: "rgb(236 245 166)" }}
                                        disabled
                                    />
                                </td>
                                <td
                                    style={{ background: "rgb(236 245 166)", textAlign: "right" }}
                                >
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareKollectionNachorderPercentValue"
                                        value={ekPlanningAllInOne.wareKollectionNachorderPercentValue}
                                        onChange={getValueCheck}
                                        style={{ background: "rgb(236 245 166)" }}
                                        disabled
                                    />
                                </td>
                            </>
                        ) : null}
                    </tr>

                    {/* Row 2 */}
                    <tr>
                        {checkBox1 ? (
                            <>
                                <td
                                    style={{ background: "rgb(236 245 166)" }}
                                    className="wes1td"
                                >
                                    NOS
                                </td>
                                <td style={{ background: "rgb(212, 236, 251)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag1"
                                        name="wareNosPercent"
                                        value={ekPlanningAllInOne.wareNosPercent}
                                        onChange={getValueCheck}
                                        autoComplete="off"
                                    />
                                </td>
                                <td style={{ background: "rgb(212, 236, 251)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag1"
                                        name="wareNosPercentValue"
                                        value={ekPlanningAllInOne.wareNosPercentValue}
                                        onChange={getValueCheck}
                                    />
                                </td>
                            </>
                        ) : null}
                        {checkBox2 ? (
                            <>
                                <td style={{ background: "rgb(212, 236, 251)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag1"
                                        name="wareNosVoOrderPercent"
                                        value={ekPlanningAllInOne.wareNosVoOrderPercent}
                                        onChange={getValueCheck}
                                    />
                                </td>
                                <td style={{ background: "rgb(212, 236, 251)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag1"
                                        name="wareNosVoOrderPercentValue"
                                        value={ekPlanningAllInOne.wareNosVoOrderPercentValue}
                                        onChange={getValueCheck}
                                    />
                                </td>
                                <td style={{ background: "rgb(236 245 166)" }}>
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareNosNachorderPercent"
                                        value={ekPlanningAllInOne.wareNosNachorderPercent}
                                        onChange={getValueCheck}
                                        style={{ background: "rgb(236 245 166)" }}
                                        disabled
                                    />
                                </td>
                                <td
                                    style={{ background: "rgb(236 245 166)", textAlign: "right" }}
                                >
                                    <input
                                        className="ekPlanning-wes1InputTag"
                                        autoComplete="off"
                                        name="wareNosNachorderPercentValue"
                                        value={ekPlanningAllInOne.wareNosNachorderPercentValue}
                                        onChange={getValueCheck}
                                        style={{ background: "rgb(236 245 166)" }}
                                        disabled
                                    />
                                </td>
                            </>
                        ) : null}
                    </tr>
                    {(checkBox1 || checkBox2 || checkBox3) && (
                        <>
                            {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
                            {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
                            {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr>
                <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
                        </>
                    )}
                </tbody>

                <tfoot>
                    <tr>
                        {checkBox1 ? (
                            <>
                                <td className="ekPlanning-total_row_for_wes2">Gesamt</td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                            </>
                        ) : null}
                        {checkBox2 ? (
                            <>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes1"></td>
                                <td className="ekPlanning-total_row_for_wes1">

                                </td>
                            </>
                        ) : null}
                        {/* {checkBox3 ? (
                            <>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes">2.210</td>
                                <td className="total_row_for_wes">1.050</td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes"></td>
                                <td className="ekPlanning-total_row_for_wes2">135.666</td>
                            </>
                        ) : null} */}
                    </tr>
                </tfoot>
            </Table>
        </div>
    )
}

export default EkPlanningWes